module.exports = __webpack_public_path__ + "static/media/28DGC11.1ab1a0d7.jpg";